import React from "react";

// queries
import { useQuery } from "@apollo/client";
import { GET_CREW_MEMBER_BY_ID_WITH_CERTIFICATIONS } from "../../../../../graphql/crewMember/crewMember.queries";

// components
import ChipContainer from "../../../../../components/chips/ChipContainer/ChipContainer.component";
import Chip from "../../../../../components/chips/Chip/Chip.component";

export default function CrewDetailCertifications({ id }) {
  let list = [];

  const { loading, error, data } = useQuery(
    GET_CREW_MEMBER_BY_ID_WITH_CERTIFICATIONS,
    {
      variables: { id },
    }
  );

  if (data && data.crewMember) {
    list = [...data.crewMember.certifications];
  }

  return (
    <ChipContainer>
      {list.map((chip, index) => {
        return <Chip key={index} label={chip.name} />;
      })}
    </ChipContainer>
  );
}
